/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section4_P2Inputs */

const en_about_section4_p2 = /** @type {(inputs: About_Section4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The codebase is written in TypeScript with strict type checking, ensuring reliability and maintainability. All tools are thoroughly tested and optimized for performance, even with large JSON files.`)
};

const ko_about_section4_p2 = /** @type {(inputs: About_Section4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코드베이스는 엄격한 타입 검사를 적용한 TypeScript로 작성되어 안정성과 유지보수성을 보장합니다. 모든 도구는 대용량 JSON 파일에서도 성능에 최적화되어 있습니다.`)
};

const ja_about_section4_p2 = /** @type {(inputs: About_Section4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードベースは厳密な型チェックを適用したTypeScriptで記述されており、信頼性と保守性を確保しています。すべてのツールは大きなJSONファイルでもパフォーマンスに最適化されています。`)
};

/**
* | output |
* | --- |
* | "The codebase is written in TypeScript with strict type checking, ensuring reliability and maintainability. All tools are thoroughly tested and optimized for ..." |
*
* @param {About_Section4_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section4_p2 = /** @type {((inputs?: About_Section4_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section4_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section4_p2(inputs)
	if (locale === "ko") return ko_about_section4_p2(inputs)
	return ja_about_section4_p2(inputs)
});